import * as types from './mutations-types'
import { merge as _merge } from 'lodash'

export default {
  [types.setCadastroInicial] (state, obj) {
    state.cadastro = obj
  },
  [types.atualizaCadastroCliente] (state, obj) {
    state.cadastro = _merge(state.cadastro, obj)
  }
}



// WEBPACK FOOTER //
// ./src/domain/leiloes/store/mutations.js